<template>
  <div class="list-container nopads pl-3 pr-3 pt-2">
    <div class="col-12 list-content">
      <div class="row">
        <!-- Driving Time -->
        <div class="col-sm-6 chart-container">
          <span class="report-title mt-0">{{ $t('trip_list.duration') }}</span>
          <span class="report-descr mt-0">{{ $t('trip_list.time_descr') }}</span>
          <div class="report-total">
            {{ getReportTotal(durationData) }}
          </div>
          <div class="row">
            <div class="col-md-6 nopads p-4">
              <pie-chart
                v-if="durationData.length"
                ref="pieDuration"
                class="routa-pie dont-print"
                :labels="labels"
                :colors="colors"
                :data="durationData"
                :title="titleDuration"
              />
              <img id="pieDurationImage" class="print-only routa-pie-print">
            </div>
            <div class="col-md-6 nopads">
              <bar-chart
                v-if="durationData.length"
                ref="barDuration"
                class="routa-bars dont-print"
                :labels="labels"
                :colors="colors"
                :data="durationData"
                :title="titleDuration"
                unit="km"
              />
              <img id="barDurationImage" class="print-only routa-bars-print">
            </div>
          </div>
        </div>
        <!-- Vehicle reservation time -->
        <div class="col-sm-6 chart-container">
          <span class="report-title mt-0">{{ $t('trip_list.vehicle_allocation') }}</span>
          <span class="report-descr mt-0">{{ $t('trip_list.allocation_descr') }}</span>
          <div class="report-total">
            {{ getReportTotal(reservationData) }}
          </div>
          <div class="row">
            <div class="col-md-6 nopads p-4">
              <pie-chart
                v-if="reservationData.length"
                ref="pieReservation"
                class="routa-pie dont-print"
                :labels="labels"
                :colors="colors"
                :data="reservationData"
                :title="titleReservation"
                unit="min"
              />
              <img id="pieReservationImage" class="print-only routa-pie-print">
            </div>
            <div class="col-md-6 nopads">
              <bar-chart
                v-if="reservationData.length"
                ref="barReservation"
                class="routa-bars dont-print"
                :labels="labels"
                :colors="colors"
                :data="reservationData"
                :title="titleReservation"
                unit="min"
              />
              <img id="barReservationImage" class="print-only routa-bars-print">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/chart/BarChart'
import PieChart from '@/components/chart/PieChart'
import {timeUtils} from "@/components/mixins/TimeUtils";

export default {
    name: 'VehicleAllocationCharts',
    components: {BarChart, PieChart},
    mixins: [timeUtils],
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data: function () {
        return {
            labels: [],
            colors: [],
            durationData: [],
            reservationData: [],
            titleDuration: this.$t('trip_list.duration'),
            titleReservation: this.$t('trip_list.vehicle_allocation'),
        }
    },
    watch: {
        results() {
            this.formatData()
        },
    },
    mounted: function () {
        this.formatData()
    },
    methods: {
        randomColor: function () {
            let color = Math.round(0xffffff * Math.random());
            return 'rgba(' + (color >> 16) + ',' + (color >> 8 & 255) + ',' + (color & 255) + ',1' + ')';
        },
        formatData: function () {
            let labels = []
            let durations = []
            let reservations = []
            let colors = []
            this.results.forEach(item => {
                    let key = null
                    if (item.vehicle_id) {
                        key = item.vehicle_id
                    } else {
                        key = 'no_vehicle'
                    }
                    if (!durations.hasOwnProperty(key)) {
                        durations[key] = {value: 0, unit: 'min', vehicle: ''}
                        reservations[key] = {value: 0, unit: 'min', vehicle: ''}
                    }
                    if (item.vehicle) {
                        labels[key] = item.vehicle
                        colors[key] = this.randomColor()
                    }
                    durations[key].vehicle = item.vehicle
                    durations[key].value += Math.round(item.duration / 60)
                    reservations[key].value += item.vehicle_allocation_time
                }
            )
            this.durationData = []
            this.colors = []
            this.labels = []
            for (let key in durations) {
                this.labels.push(labels[key])
                this.durationData.push(durations[key])
                this.reservationData.push(reservations[key])
                this.colors.push(colors[key])
            }
        },
        getReportTotal: function (reportData) {
            let total = reportData.reduce((acc, dataValue) => parseInt(dataValue.value) + acc, 0);
            let unit = reportData[0] && reportData[0].unit ? reportData[0].unit : '';
            if (unit === 'min') {
                total = this.getWorkTime(total)
                unit = 'h'
            }
            return `${this.$t('daily_summary.report_total')} ${total} ${unit}`;
        },
    }
}

</script>
<style>
.report-total {
    font-weight: bold;
    font-size: 0.9em;
    color: #5b5b5c;
    text-align: center !important;
    margin: .2em;
}
</style>
